/**
 * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
/**
 * @module font
 */
export { default as Font } from './font.js';
export { default as FontBackgroundColor } from './fontbackgroundcolor.js';
export { default as FontColor } from './fontcolor.js';
export { default as FontFamily } from './fontfamily.js';
export { default as FontSize } from './fontsize.js';
export { default as FontBackgroundColorEditing } from './fontbackgroundcolor/fontbackgroundcolorediting.js';
export { default as FontBackgroundColorUI } from './fontbackgroundcolor/fontbackgroundcolorui.js';
export { default as FontColorEditing } from './fontcolor/fontcolorediting.js';
export { default as FontColorUI } from './fontcolor/fontcolorui.js';
export { default as FontFamilyEditing } from './fontfamily/fontfamilyediting.js';
export { default as FontFamilyUI } from './fontfamily/fontfamilyui.js';
export { default as FontSizeEditing } from './fontsize/fontsizeediting.js';
export { default as FontSizeUI } from './fontsize/fontsizeui.js';
import './augmentation.js';
